import { render, staticRenderFns } from "./RolesResponsibilitiesPicker.vue?vue&type=template&id=42a0c36d&scoped=true"
import script from "./RolesResponsibilitiesPicker.vue?vue&type=script&lang=js"
export * from "./RolesResponsibilitiesPicker.vue?vue&type=script&lang=js"
import style0 from "./RolesResponsibilitiesPicker.vue?vue&type=style&index=0&id=42a0c36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a0c36d",
  null
  
)

export default component.exports